module.exports = __webpack_public_path__ + "img/next.7c2cf6d2.png";